/* eslint-disable react/jsx-props-no-spreading */
import {Button} from 'letrus-ui';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconName} from '@fortawesome/fontawesome-svg-core';
import styles from './OlympicsRegistrationResponse.module.scss';

const STATUS_INFO: {
  [key: string]: {
    title: string;
    message: string;
    nextSteps?: string[];
    icon: IconName;
  };
} = {
  loading: {
    title: 'Registrando...',
    message: 'Por favor, aguarde enquanto processamos seu registro.',
    icon: 'spinner',
  },
  success: {
    title: 'Inscrição confirmada!',
    message: 'Você está oficialmente inscrito na Olimpíada Linguagem em Ação',
    nextSteps: [
      'A Olimpíada Linguagem em Ação acontecerá entre os dias 17 e 21 de agosto de 2026',
      'Sua jornada começa agora: acesse sua trilha e explore atividades rápidas e interativas.',
    ],
    icon: 'check-circle',
  },
  error: {
    title: 'Erro na Inscrição',
    message: 'Por favor, verifique os dados e tente novamente.',
    icon: 'exclamation-circle',
  },
};

interface OlympicsRegistrationResponseProps {
  onGoBack(): void;
  onFinish(): void;
  isLoading: boolean;
  isSuccess: boolean;
  errors?: Record<string, string[]>;
}

function OlympicsRegistrationResponse({
  onFinish,
  onGoBack,
  isLoading,
  isSuccess,
  errors,
}: OlympicsRegistrationResponseProps) {
  const status = isLoading ? 'loading' : isSuccess ? 'success' : 'error';

  return (
    <>
      <div className={`${styles.responseContainer} ${styles[status]}`}>
        <h2 className={styles.title}>{STATUS_INFO[status].title}</h2>
        <div className={`${styles.iconContainer} ${styles[status]}`}>
          <FontAwesomeIcon
            size="3x"
            spin={status === 'loading'}
            icon={STATUS_INFO[status].icon}
            data-testid={`icon-${STATUS_INFO[status].icon}`}
          />
        </div>
        <p className={styles.message}>{STATUS_INFO[status].message}</p>

        {isSuccess && (
          <ul className={styles.messageList}>
            <h3>Próximos passos:</h3>
            {STATUS_INFO[status].nextSteps?.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ul>
        )}
        {!!errors && (
          <ul className={styles.messageList}>
            {Object.entries(errors).map(([field, fieldErrors]) =>
              fieldErrors?.map((error) => (
                <li key={`${field}-${error}`}>{error}</li>
              )),
            )}
          </ul>
        )}
      </div>

      <div className={styles.controls}>
        {!isSuccess && (
          <Button variant="secondary" onClick={onGoBack} disabled={isLoading}>
            <FontAwesomeIcon icon="arrow-left" /> Voltar
          </Button>
        )}

        {isSuccess && (
          <Button onClick={() => onFinish()}>
            <FontAwesomeIcon icon="check" /> Ver minhas atividades
          </Button>
        )}
      </div>
    </>
  );
}

export default OlympicsRegistrationResponse;
